// @flow

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

const roomGQL = gql`
  query room($id: Int, $uid: String) {
    room(id: $id, uid: $uid, rentType: DAY_TIME) {
      id
      registeredFavoriteLists {
        results {
          id
        }
      }
    }
  }
`

export default function(component: any) {
  return graphql(roomGQL, {
    options: props => ({
      variables: {
        uid: props.roomUid,
      },
    }),
  })(component)
}



// WEBPACK FOOTER //
// ./src/containers/organisms/FavoriteSelectModal/graphql.js